window._vue_richtext_widgets || (window._vue_richtext_widgets = {});
const s = (e) => !!window._vue_richtext_widgets[e], o = (e, t, r = (i) => {
}) => {
  if (window._vue_richtext_widgets[e]) {
    console.error("Widget for id " + e + " already registered");
    return;
  }
  window._vue_richtext_widgets[e] = {
    id: e,
    callback: t,
    onDestroy: r
  };
}, c = (e, { richObjectType: t, richObject: r, accessible: i, interactive: n }) => {
  if (t !== "open-graph") {
    if (!window._vue_richtext_widgets[t]) {
      console.error("Widget for rich object type " + t + " not registered");
      return;
    }
    window._vue_richtext_widgets[t].callback(e, { richObjectType: t, richObject: r, accessible: i, interactive: n });
  }
}, u = (e, t) => {
  e !== "open-graph" && window._vue_richtext_widgets[e] && window._vue_richtext_widgets[e].onDestroy(t);
};
window._registerWidget = o;
window._vue_richtext_custom_picker_elements || (window._vue_richtext_custom_picker_elements = {});
class w {
  /**
   * @param {HTMLElement} element The HTML element
   * @param {object} object The object
   */
  constructor(t, r) {
    this.element = t, this.object = r;
  }
}
const l = (e) => !!window._vue_richtext_custom_picker_elements[e], d = (e) => {
  const t = window._vue_richtext_custom_picker_elements[e]?.size;
  return ["small", "normal", "large", "full"].includes(t) ? t : null;
}, _ = (e, t, r = (n) => {
}, i = "large") => {
  if (window._vue_richtext_custom_picker_elements[e]) {
    console.error("Custom reference picker element for id " + e + " already registered");
    return;
  }
  window._vue_richtext_custom_picker_elements[e] = {
    id: e,
    callback: t,
    onDestroy: r,
    size: i
  };
}, m = (e, { providerId: t, accessible: r }) => {
  if (!window._vue_richtext_custom_picker_elements[t]) {
    console.error("Custom reference picker element for reference provider ID " + t + " not registered");
    return;
  }
  return window._vue_richtext_custom_picker_elements[t].callback(e, { providerId: t, accessible: r });
}, g = (e, t, r) => {
  window._vue_richtext_custom_picker_elements[e] && window._vue_richtext_custom_picker_elements[e].onDestroy(t, r);
};
window._registerCustomPickerElement = _;
export {
  w as NcCustomPickerRenderResult,
  g as destroyCustomPickerElement,
  u as destroyWidget,
  d as getCustomPickerElementSize,
  l as isCustomPickerElementRegistered,
  s as isWidgetRegistered,
  _ as registerCustomPickerElement,
  o as registerWidget,
  m as renderCustomPickerElement,
  c as renderWidget
};
